import Axios from 'axios';
import type { AxiosRequestHeaders } from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { PlatformType } from '@src/constants/request-data';

export const refreshToken = () => {
  let headers: AxiosRequestHeaders = {
    'X-Process-ID': uuidv4(),
    'Content-type': 'application/json',
    'X-Platform-Type': PlatformType,
  };

  const csrfToken = localStorage.getItem('csrfToken');

  if (csrfToken) {
    headers = {
      ...headers,
      'X-CSRF-Token': csrfToken,
    };
  }

  return Axios.post(
    `${window.envUrls.BASEURL}/v1/user/refresh-token`,
    {},
    {
      withCredentials: true,
      headers,
    }
  );
};
